import { Component, OnInit, OnDestroy, ViewEncapsulation, ChangeDetectionStrategy, Output, EventEmitter } from '@angular/core';
import { Institution } from '@gwc/datasources/gwc-api/types/institution.types';
import { Observable, of, Subject, take, takeUntil, tap } from 'rxjs';
import { CasualHireFormService } from '../../casual-hire-form.service';
import { faCheckCircle } from '@fortawesome/free-solid-svg-icons';
import { f3Animations } from '@f3/animations';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { AsyncPipe } from '@angular/common';

@Component({
    selector: 'select-institution',
    templateUrl: './select-institution.component.html',
    styleUrls: ['./select-institution.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    animations: f3Animations,
    standalone: true,
    imports: [FaIconComponent, AsyncPipe]
})
export class FormStepperSelectInstitutionComponent implements OnInit, OnDestroy {

    // @Public Properties
    public faCheckCircle = faCheckCircle

    public institutions$: Observable<Institution[]> = of([])

    public selectedInstitution: Institution | null = null;

    // @Private Properties
    private _unsubscribeAll: Subject<any> = new Subject;


    /**
    * Constructor
    */
    constructor(
        private _casualHireFormService: CasualHireFormService
    ) { }


    //--------------------------------------------------------------------------------
    // @Lifecycle Hooks
    //--------------------------------------------------------------------------------

    /**
    * OnInit
    */
    ngOnInit(): void {

        this.institutions$ = this._casualHireFormService.institutions$

        //get the order data
        this._casualHireFormService.orderData$.pipe(
            take(1)
        ).subscribe({
            next: (orderData) => {
                this.selectedInstitution = orderData.institution

                orderData.institution ? this._casualHireFormService.updateStepValidity(true) : this._casualHireFormService.updateStepValidity(false)

            }
        })  

    }

    /**
    * OnDestroy
    */
    ngOnDestroy() {
		this._casualHireFormService.updateStepValidity(false)

        this._unsubscribeAll.next(null);
        this._unsubscribeAll.complete();
    }


    //--------------------------------------------------------------------------------
    // @Public Methods
    //--------------------------------------------------------------------------------

    /**
     * Handle the clicking on an institution
     */
    public toggleInstitution(institution: Institution) {
        if(this.selectedInstitution?.institution_id === institution.institution_id) {
            this.selectedInstitution = null;
            this._casualHireFormService.addToOrderData('institution', null, false)
        } else {
            this.selectedInstitution = institution;
            this._casualHireFormService.addToOrderData('institution', this.selectedInstitution, true)
        }
    }

}